import { Button, Text, VStack } from "@bpba/ui-components";
import React from "react";

type ResultProps = {
  children: React.ReactNode;
  handleReset: () => void;
};

export const Result = (props: ResultProps) => {
  if (!props) return <></>;

  return (
    <VStack>
      {props.children}
      <Text tabIndex={0}>Gracias por confiar en nosotros.</Text>
      <Button
        onClick={() => props.handleReset()}
        variant="secondary"
        py={"10px !important"}
      >
        Volver
      </Button>
    </VStack>
  );
};
